// extracted by mini-css-extract-plugin
module.exports = {"freightComponent":"freight_freightComponent__tvDl8","freightHeadline":"freight_freightHeadline__UxEox","freightCost":"freight_freightCost__tsXNK"};